// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"d8c74882","787":"ec2c3541","804":"bf02151e","941":"903d1eee"}[chunkId] + ".chunk.js";
};